export default "__VITE_ASSET__81f16fac__"